<template>
    <div class="departure">
        <a :href="'/departure/' + departurePref.slug + '/' + value.slug + '/'" class="box" v-for="(value, key) in departureList" :value="key">
            <dl>
                <dt class="region">{{value.name}}発</dt>
                <dd class="price">{{priceList[value.id]}}</dd>
                <dd class="arrow"><img loading="lazy" src="/user/assets/images/common/arrow_b.png" alt="次へ"></dd>
            </dl>
        </a>
        <vue-element-loading :active="isLoading"  :is-full-screen="false"/>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            departure_area : {type: String, require: true},
            departure_pref : {type: String, require: true},
            departure_list : {type: String, require: true},
        },
        setup (props, context) {
            let departureArea = JSON.parse(props.departure_area)
            let departurePref = JSON.parse(props.departure_pref)
            let departureList = JSON.parse(props.departure_list)
            const isLoading = ref(true)

            let apiUrlList = {}
            const priceList = ref([])
            Object.keys(departureList).forEach(function (key) {
                let currentDate = dayjs().startOf('month')
                let urlList = {}
                let departureAreaSlug = departureArea[Object.entries(departurePref.parentIdList)[0][1]].slug

                for (let i = 0; i < 6; i++) {
                    let paramList = [
                        "deptArea_" + departureAreaSlug,
                        "deptPref_" + departurePref.slug,
                        "dept_" + departureList[key].slug,
                        "date_" + currentDate.format("YYYYMM"),
                    ]
                    paramList = paramList.filter(Boolean)

                    let url = paramList.join("/")
                    urlList[currentDate.format("YYYYMM")] = url

                    currentDate = dayjs(currentDate.add(1, 'months').startOf('month'))
                }

                apiUrlList[departureList[key].id] = urlList
                priceList.value[departureList[key].id] = "読込中"
            })

            // 完了時
            onMounted(() => {
                let urlList = []
                Object.keys(apiUrlList).forEach(function (departureId) {
                    Object.keys(apiUrlList[departureId]).forEach(function (date) {
                        urlList.push(apiUrlList[departureId][date])
                    })
                })

                if(urlList.length == 0) {
                    isLoading.value = false
                    return;
                }

                axios.post("/api/bestPrice/", {
                    urlList: urlList,
                })
                .then(function (response) {
                    Object.keys(apiUrlList).forEach(function (departureId) {
                        let bestPrice = null
                        Object.keys(apiUrlList[departureId]).forEach(function (date) {
                            if (response.data.bestPriceList[apiUrlList[departureId][date]] != null && (bestPrice == null || bestPrice < response.data.bestPriceList[apiUrlList[departureId][date]].price)){
                                bestPrice = response.data.bestPriceList[apiUrlList[departureId][date]].price
                            }
                        })

                        if (bestPrice) {
                            priceList.value[departureId] = bestPrice.toLocaleString() + "円～"
                        } else {
                            priceList.value[departureId] = "-"
                        }
                    })

                    isLoading.value = false
                })
            })

            return {
                departurePref,
                departureList,
                priceList,
                isLoading,
            }
        },
    })
</script>